export const Footer = () => (
    <footer style={{
        width: '100%',
        textAlign: 'center',
        padding: '10px 0',
        fontSize: '14px',
        marginTop: 'auto' // 콘텐츠가 끝나는 곳에 위치
    }}>
        [링크니티] 주소모음 링크모음 모든주소 모든링크 사이트 &copy; All rights reserved.
    </footer>
);